import { Map } from 'immutable';

import { INITIALIZE, UPDATE } from './types';

const initialState = new Map({
  loading: true,
  pageIndex: 0,
  shouldCallInit: true,
});

const containerReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case INITIALIZE.REQUEST:
      return state.set('loading', true);
    case INITIALIZE.SUCCESS:
      return state.withMutations((newState) => {
        newState
          .set('loading', false);
      });
    case UPDATE.PAGE_INDEX:
      return state.set('pageIndex', payload);
    case UPDATE.SHOULD_CALL_INIT:
      return state.set('shouldCallInit', payload);
    default:
      return state;
  }
};

export default containerReducer;
export { initialState };
